export const WEBSITE_NAME = "SendSprint";

export const CAMPAIGN_ID_STORE_NAME = "campaign_id";
export const CAMPAIGN_ID_QUERY_KEY = "c";
